import type markdownIt from "markdown-it";
import type { InjectionKey } from "vue";

export const MarkdownItInjectionKey = Symbol("MarkdownItInjectionKey") as InjectionKey<{
  md: markdownIt;
  contentPrefix: string;
}>;
